<div class="scan-status-badges">
	@if (showOcr()) {
		<span class="ocr-badge {{ ocrMeta().modifier }}" [matTooltip]="ocrMeta().tooltip">
			<mat-icon><i class="fa-solid {{ ocrMeta().icon }}" aria-hidden="true"></i></mat-icon>
			<span>{{ ocrMeta().label }}</span>
		</span>
	}
	<span class="cost-badge {{ costMeta().modifier }}" [matTooltip]="costMeta().tooltip">
		<mat-icon><i class="fa-solid {{ costMeta().icon }}" aria-hidden="true"></i></mat-icon>
		<span>{{ costMeta().label }}</span>
	</span>
	@if (showArchive()) {
		<span class="archive-badge {{ archiveMeta().modifier }}" [matTooltip]="archiveMeta().tooltip">
			<mat-icon><i class="fa-solid {{ archiveMeta().icon }}" aria-hidden="true"></i></mat-icon>
			<span>{{ archiveMeta().label }}</span>
		</span>
	}
</div>
